(function () {
  'use strict';

  var STORAGE_KEY = 'inspiredgrabs_product_compare_v1';
  var MAX_PRODUCTS = 4;
  var noticeTimer = null;
  var previousBodyOverflow = '';
  var intelligenceCache = {};

  function cleanProductId(value) {
    return String(value || '')
      .replace(/"/g, '')
      .trim();
  }

  function getStoredProducts() {
    try {
      var stored = window.localStorage.getItem(STORAGE_KEY);

      if (!stored) {
        return [];
      }

      var savedItems = JSON.parse(stored);

      if (!Array.isArray(savedItems)) {
        return [];
      }

      return savedItems
        .map(function (item) {
          if (
            typeof item === 'string' ||
            typeof item === 'number'
          ) {
            return {
              id: cleanProductId(item),
              title: '',
              url: '',
              image: '',
              price: '',
              comparePrice: '',
              intelligence: null
            };
          }

          if (item && typeof item === 'object') {
            return {
              id: cleanProductId(item.id),
              title: item.title || '',
              url: item.url || '',
              image: item.image || '',
              price: item.price || '',
              comparePrice: item.comparePrice || '',
              intelligence:
                item.intelligence && typeof item.intelligence === 'object'
                  ? item.intelligence
                  : null
            };
          }

          return null;
        })
        .filter(function (product) {
          return product && product.id;
        })
        .slice(0, MAX_PRODUCTS);
    } catch (error) {
      return [];
    }
  }

  function saveProducts(products) {
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(products.slice(0, MAX_PRODUCTS))
      );
    } catch (error) {
      /*
        Continue normally if browser storage is unavailable.
      */
    }
  }

  function normalizeImageUrl(value) {
    var url = String(value || '').trim();

    if (!url) {
      return '';
    }

    if (url.indexOf('//') === 0) {
      return window.location.protocol + url;
    }

    return url;
  }

  function getProductData(card) {
    var wishlistButton = card.querySelector(
      '.swym-add-to-wishlist-view-product[data-product-id]'
    );

    if (!wishlistButton) {
      wishlistButton = card.querySelector('[data-product-id]');
    }

    var titleLink = card.querySelector(
      '.spf-product-card__title a'
    );

    var mainImage = card.querySelector(
      '.spf-product-card__image-main'
    );

    if (!mainImage) {
      mainImage = card.querySelector(
        '.spf-product-card__image'
      );
    }

    var salePrice = card.querySelector(
      '.spf-product-card__saleprice'
    );

    var regularPrice = card.querySelector(
      '.spf-product-card__price'
    );

    var oldPrice = card.querySelector(
      '.spf-product-card__oldprice'
    );

    var productId = wishlistButton
      ? cleanProductId(
          wishlistButton.getAttribute('data-product-id')
        )
      : '';

    var productTitle = titleLink
      ? titleLink.textContent.trim()
      : 'Product';

    var productUrl = titleLink
      ? titleLink.href
      : '';

    var productImage = '';

    if (mainImage) {
      productImage =
        mainImage.getAttribute('data-src') ||
        mainImage.currentSrc ||
        mainImage.src ||
        '';
    }

    productImage = normalizeImageUrl(productImage);

    var productPrice = '';

    if (salePrice) {
      productPrice = salePrice.textContent.trim();
    } else if (regularPrice) {
      productPrice = regularPrice.textContent.trim();
    }

    var comparePrice = oldPrice
      ? oldPrice.textContent.trim()
      : '';

    return {
      id: productId,
      title: productTitle,
      url: productUrl,
      image: productImage,
      price: productPrice,
      comparePrice: comparePrice,
      intelligence: null
    };
  }

  function getProductHandle(product) {
    try {
      var url = new URL(
        product && product.url ? product.url : '',
        window.location.origin
      );

      var match = url.pathname.match(/\/products\/([^/?#]+)/);

      return match && match[1]
        ? decodeURIComponent(match[1])
        : '';
    } catch (error) {
      return '';
    }
  }

  function buildIntelligenceRequestUrl(product) {
    var handle = getProductHandle(product);

    if (!handle) {
      return '';
    }

    var url = new URL(
      '/products/' + encodeURIComponent(handle),
      window.location.origin
    );

    url.searchParams.set(
      'section_id',
      'ig-product-intelligence'
    );

    return url.toString();
  }

  function parseIntelligenceResponse(responseText) {
    var parser = new DOMParser();
    var documentFragment = parser.parseFromString(
      responseText,
      'text/html'
    );

    var dataNode = documentFragment.querySelector(
      '[data-ig-product-intelligence]'
    );

    if (!dataNode) {
      return null;
    }

    try {
      return JSON.parse(dataNode.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function fetchProductIntelligence(product) {
    var handle = getProductHandle(product);

    if (!handle) {
      return Promise.resolve(null);
    }

    if (Object.prototype.hasOwnProperty.call(
      intelligenceCache,
      handle
    )) {
      return intelligenceCache[handle];
    }

    var requestUrl = buildIntelligenceRequestUrl(product);

    if (!requestUrl) {
      return Promise.resolve(null);
    }

    intelligenceCache[handle] = window
      .fetch(requestUrl, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html'
        }
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Product Intelligence request failed: ' +
            response.status
          );
        }

        return response.text();
      })
      .then(function (responseText) {
        return parseIntelligenceResponse(responseText);
      })
      .catch(function () {
        return null;
      });

    return intelligenceCache[handle];
  }

  function saveProductIntelligence(productId, intelligence) {
    if (!intelligence) {
      return;
    }

    var products = getStoredProducts();
    var changed = false;

    products = products.map(function (product) {
      if (
        String(product.id) !==
        String(productId)
      ) {
        return product;
      }

      changed = true;

      return {
        id: product.id,
        title: product.title,
        url: product.url,
        image: product.image,
        price: product.price,
        comparePrice: product.comparePrice,
        intelligence: intelligence
      };
    });

    if (changed) {
      saveProducts(products);
    }
  }

  function hasCurrentProductIntelligence(product) {
    return Boolean(
      product &&
      product.intelligence &&
      product.intelligence.schema_version === '1.2' &&
      product.intelligence.intelligence &&
      typeof product.intelligence.intelligence === 'object'
    );
  }

  function hydrateProductIntelligence(product) {
    if (!product || !product.id) {
      return Promise.resolve(null);
    }

    if (hasCurrentProductIntelligence(product)) {
      return Promise.resolve(product.intelligence);
    }

    return fetchProductIntelligence(product).then(
      function (intelligence) {
        if (intelligence) {
          product.intelligence = intelligence;
          saveProductIntelligence(
            product.id,
            intelligence
          );
        }

        return intelligence;
      }
    );
  }

  function hydrateStoredProducts() {
    getStoredProducts().forEach(function (product) {
      hydrateProductIntelligence(product);
    });
  }

  function findStoredProduct(productId) {
    return getStoredProducts().find(function (product) {
      return String(product.id) === String(productId);
    });
  }

  function isProductSelected(productId) {
    return Boolean(findStoredProduct(productId));
  }

  function upgradeStoredProductData(card) {
    var currentProduct = getProductData(card);

    if (!currentProduct.id) {
      return;
    }

    var products = getStoredProducts();
    var changed = false;

    products = products.map(function (storedProduct) {
      if (
        String(storedProduct.id) !==
        String(currentProduct.id)
      ) {
        return storedProduct;
      }

      if (
        !storedProduct.title ||
        !storedProduct.url ||
        !storedProduct.image ||
        !storedProduct.price
      ) {
        changed = true;

        return {
          id: currentProduct.id,
          title:
            currentProduct.title || storedProduct.title,
          url:
            currentProduct.url || storedProduct.url,
          image:
            currentProduct.image || storedProduct.image,
          price:
            currentProduct.price || storedProduct.price,
          comparePrice:
            currentProduct.comparePrice ||
            storedProduct.comparePrice,
          intelligence:
            storedProduct.intelligence || null
        };
      }

      return storedProduct;
    });

    if (changed) {
      saveProducts(products);
    }
  }

  function addCompareCheckboxes() {
    document
      .querySelectorAll('.spf-product-card')
      .forEach(function (card) {
        upgradeStoredProductData(card);

        if (
          card.querySelector('[data-ig-compare-control]')
        ) {
          return;
        }

        var product = getProductData(card);

        if (!product.id) {
          return;
        }

        var control = document.createElement('div');
        control.className = 'ig-compare-card-control';
        control.setAttribute(
          'data-ig-compare-control',
          ''
        );

        var label = document.createElement('label');
        label.className = 'ig-compare-card-label';

        var checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.className = 'ig-compare-checkbox';
        checkbox.setAttribute('data-ig-compare', '');
        checkbox.setAttribute(
          'data-product-id',
          product.id
        );
        checkbox.setAttribute(
          'aria-label',
          'Compare ' + product.title
        );

        checkbox.checked = isProductSelected(product.id);

        var text = document.createElement('span');
        text.className = 'ig-compare-card-text';
        text.textContent = 'Compare';

        label.appendChild(checkbox);
        label.appendChild(text);
        control.appendChild(label);

        var productInfo = card.querySelector(
          '.spf-product__info'
        );

        if (productInfo) {
          productInfo.insertBefore(
            control,
            productInfo.firstChild
          );
        } else {
          card.appendChild(control);
        }
      });
  }

  function createCompareTray() {
    if (document.getElementById('ig-compare-tray')) {
      return;
    }

    var tray = document.createElement('div');
    tray.id = 'ig-compare-tray';
    tray.className = 'ig-compare-tray';
    tray.hidden = true;
    tray.setAttribute('aria-live', 'polite');

    tray.innerHTML =
      '<div class="ig-compare-tray-inner">' +
        '<div class="ig-compare-tray-summary">' +
          '<strong class="ig-compare-tray-title">' +
            'Compare Products' +
          '</strong>' +

          '<span id="ig-compare-count" ' +
            'class="ig-compare-count">' +
            '0 products selected' +
          '</span>' +
        '</div>' +

        '<div id="ig-compare-tray-products" ' +
          'class="ig-compare-tray-products">' +
        '</div>' +

        '<div class="ig-compare-tray-actions">' +
          '<button id="ig-compare-clear" ' +
            'class="ig-compare-clear" type="button">' +
            'Clear All' +
          '</button>' +

          '<button id="ig-compare-open" ' +
            'class="ig-compare-open" type="button" disabled>' +
            'Compare Products' +
          '</button>' +
        '</div>' +
      '</div>' +

      '<div id="ig-compare-notice" ' +
        'class="ig-compare-notice" role="status" hidden>' +
      '</div>';

    document.body.appendChild(tray);
  }

  function createTrayProduct(product) {
    var item = document.createElement('div');
    item.className = 'ig-compare-tray-product';
    item.setAttribute(
      'data-ig-tray-product',
      product.id
    );
    item.setAttribute(
      'title',
      product.title || 'Selected product'
    );

    if (product.image) {
      var image = document.createElement('img');
      image.src = product.image;
      image.alt = product.title || 'Selected product';
      image.loading = 'lazy';

      item.appendChild(image);
    } else {
      var placeholder = document.createElement('span');
      placeholder.className =
        'ig-compare-tray-product-placeholder';
      placeholder.textContent = 'Product';

      item.appendChild(placeholder);
    }

    var removeButton = document.createElement('button');
    removeButton.type = 'button';
    removeButton.className = 'ig-compare-tray-remove';
    removeButton.setAttribute(
      'data-ig-remove-product',
      product.id
    );
    removeButton.setAttribute(
      'aria-label',
      'Remove ' +
        (product.title || 'product') +
        ' from comparison'
    );
    removeButton.textContent = '×';

    item.appendChild(removeButton);

    return item;
  }

  function syncCompareCheckboxes() {
    var selectedIds = getStoredProducts().map(
      function (product) {
        return String(product.id);
      }
    );

    document
      .querySelectorAll('[data-ig-compare]')
      .forEach(function (checkbox) {
        var productId = String(
          checkbox.getAttribute('data-product-id') || ''
        );

        checkbox.checked =
          selectedIds.indexOf(productId) !== -1;
      });
  }

  function renderCompareTray() {
    createCompareTray();

    var tray = document.getElementById(
      'ig-compare-tray'
    );

    var count = document.getElementById(
      'ig-compare-count'
    );

    var productHolder = document.getElementById(
      'ig-compare-tray-products'
    );

    var compareButton = document.getElementById(
      'ig-compare-open'
    );

    var products = getStoredProducts();
    var selectedCount = products.length;

    tray.hidden = selectedCount === 0;

    count.textContent =
      selectedCount +
      (selectedCount === 1
        ? ' product selected'
        : ' products selected');

    compareButton.disabled = selectedCount < 2;

    productHolder.innerHTML = '';

    products.forEach(function (product) {
      productHolder.appendChild(
        createTrayProduct(product)
      );
    });

    syncCompareCheckboxes();
  }

  function showCompareNotice(message) {
    createCompareTray();

    var notice = document.getElementById(
      'ig-compare-notice'
    );

    if (!notice) {
      return;
    }

    notice.textContent = message;
    notice.hidden = false;

    window.clearTimeout(noticeTimer);

    noticeTimer = window.setTimeout(function () {
      notice.hidden = true;
    }, 3500);
  }

  function ensureCompareSectionStyles() {
    if (document.getElementById('ig-compare-section-styles')) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'ig-compare-section-styles';
    style.textContent =
      '.ig-compare-section-row th{' +
        'background:#f7f7f8;' +
        'border-top:2px solid #e6e6e8;' +
        'border-bottom:1px solid #dddddf;' +
        'color:#1f2937;' +
        'font-weight:800;' +
        'letter-spacing:.08em;' +
        'padding:12px 14px;' +
        'text-align:left;' +
        'text-transform:uppercase;' +
      '}' +
      '.ig-compare-section-row:first-child th{' +
        'border-top:0;' +
      '}' +
      '@media (max-width:749px){' +
        '.ig-compare-section-row th{' +
          'font-size:13px;' +
          'padding:10px 12px;' +
        '}' +
      '}';

    document.head.appendChild(style);
  }

  function createCompareModal() {
    ensureCompareSectionStyles();

    if (document.getElementById('ig-compare-modal')) {
      return;
    }

    var modal = document.createElement('div');
    modal.id = 'ig-compare-modal';
    modal.className = 'ig-compare-modal';
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');

    modal.innerHTML =
      '<div class="ig-compare-modal-overlay" ' +
        'data-ig-compare-close>' +
      '</div>' +

      '<div class="ig-compare-dialog" ' +
        'role="dialog" ' +
        'aria-modal="true" ' +
        'aria-labelledby="ig-compare-dialog-title">' +

        '<div class="ig-compare-dialog-header">' +
          '<div class="ig-compare-dialog-heading">' +
            '<h2 id="ig-compare-dialog-title">' +
              'Compare Products' +
            '</h2>' +

            '<p>' +
              'Review your selected products side by side.' +
            '</p>' +
          '</div>' +

          '<button class="ig-compare-dialog-close" ' +
            'type="button" ' +
            'data-ig-compare-close ' +
            'aria-label="Close product comparison">' +
            '×' +
          '</button>' +
        '</div>' +

        '<div id="ig-compare-table-wrap" ' +
          'class="ig-compare-table-wrap">' +
        '</div>' +

        '<div class="ig-compare-dialog-footer">' +
          '<button id="ig-compare-modal-clear" ' +
            'class="ig-compare-dialog-clear" ' +
            'type="button">' +
            'Clear All' +
          '</button>' +

          '<button class="ig-compare-dialog-done" ' +
            'type="button" ' +
            'data-ig-compare-close>' +
            'Continue Shopping' +
          '</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(modal);
  }

  function createTextCell(
    tagName,
    className,
    text
  ) {
    var cell = document.createElement(tagName);

    if (className) {
      cell.className = className;
    }

    cell.textContent = text || '—';

    return cell;
  }

  function normalizeCompareValue(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function valuesAreDifferent(values) {
    var normalizedValues = values.map(function (value) {
      return normalizeCompareValue(value);
    });

    var uniqueValues = normalizedValues.filter(
      function (value, index, array) {
        return array.indexOf(value) === index;
      }
    );

    return uniqueValues.length > 1;
  }

  function addDifferenceBadge(labelCell) {
    var badge = document.createElement('span');
    badge.className = 'ig-compare-difference-badge';
    badge.textContent = 'Different';

    labelCell.appendChild(badge);
  }

  function createModalProductHeading(product) {
    var heading = document.createElement('th');
    heading.className =
      'ig-compare-product-heading';
    heading.scope = 'col';

    var removeButton = document.createElement('button');
    removeButton.type = 'button';
    removeButton.className =
      'ig-compare-product-remove';
    removeButton.setAttribute(
      'data-ig-remove-product',
      product.id
    );
    removeButton.setAttribute(
      'aria-label',
      'Remove ' +
        (product.title || 'product') +
        ' from comparison'
    );
    removeButton.textContent = '×';

    heading.appendChild(removeButton);

    var imageHolder = document.createElement('div');
    imageHolder.className =
      'ig-compare-product-image';

    if (product.image) {
      var image = document.createElement('img');
      image.src = product.image;
      image.alt = product.title || 'Product';
      image.loading = 'lazy';

      imageHolder.appendChild(image);
    } else {
      var imagePlaceholder =
        document.createElement('span');

      imagePlaceholder.className =
        'ig-compare-product-image-placeholder';

      imagePlaceholder.textContent =
        'No image available';

      imageHolder.appendChild(imagePlaceholder);
    }

    heading.appendChild(imageHolder);

    if (product.url) {
      var titleLink = document.createElement('a');
      titleLink.className =
        'ig-compare-product-title';
      titleLink.href = product.url;
      titleLink.target = '_blank';
      titleLink.rel = 'noopener noreferrer';
      titleLink.textContent =
        product.title || 'View Product';

      heading.appendChild(titleLink);
    } else {
      var title = document.createElement('span');
      title.className =
        'ig-compare-product-title';
      title.textContent =
        product.title || 'Product';

      heading.appendChild(title);
    }

    return heading;
  }

  function humanizeCompareKey(value) {
    return String(value || '')
      .replace(/[-_]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\b\w/g, function (character) {
        return character.toUpperCase();
      });
  }

  function formatIntelligenceValue(value) {
    if (
      value === null ||
      typeof value === 'undefined' ||
      value === ''
    ) {
      return '';
    }

    if (Array.isArray(value)) {
      return value
        .map(function (item) {
          return formatIntelligenceValue(item);
        })
        .filter(Boolean)
        .join(', ');
    }

    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No';
    }

    if (typeof value === 'number') {
      return String(value);
    }

    if (typeof value === 'object') {
      var preferredKeys = [
        'title',
        'name',
        'label',
        'display_name',
        'value'
      ];

      for (var index = 0; index < preferredKeys.length; index += 1) {
        var preferredValue = value[preferredKeys[index]];

        if (
          preferredValue !== null &&
          typeof preferredValue !== 'undefined' &&
          preferredValue !== ''
        ) {
          return formatIntelligenceValue(preferredValue);
        }
      }

      if (value.handle) {
        return humanizeCompareKey(value.handle);
      }

      return '';
    }

    return String(value).trim();
  }

  function getIntelligenceValue(product, path) {
    var currentValue =
      product && product.intelligence
        ? product.intelligence
        : null;

    for (var index = 0; index < path.length; index += 1) {
      if (
        currentValue === null ||
        typeof currentValue === 'undefined'
      ) {
        return '';
      }

      currentValue = currentValue[path[index]];
    }

    return formatIntelligenceValue(currentValue);
  }

  function appendTaxonomyRows(tbody, products) {
    var rows = [
      {
        label: 'Category',
        path: ['taxonomy', 'category']
      },
      {
        label: 'Type',
        path: ['taxonomy', 'type']
      },
      {
        label: 'Subcategory',
        path: ['taxonomy', 'subcategory']
      },
      {
        label: 'Product Family',
        path: ['architecture', 'product_family']
      },
      {
        label: 'Filter Profile',
        path: ['architecture', 'filter_profile']
      }
    ];

    rows.forEach(function (rowDefinition) {
      appendStandardRow(
        tbody,
        rowDefinition.label,
        products,
        function (product) {
          return getIntelligenceValue(
            product,
            rowDefinition.path
          );
        }
      );
    });
  }

  function getIntelligenceSection(product, sectionKey) {
    if (
      !product ||
      !product.intelligence ||
      !product.intelligence.intelligence ||
      typeof product.intelligence.intelligence !== 'object'
    ) {
      return {};
    }

    var section =
      product.intelligence.intelligence[sectionKey];

    return section && typeof section === 'object'
      ? section
      : {};
  }

  function hasDisplayValue(value) {
    return formatIntelligenceValue(value) !== '';
  }

  function getSectionKeys(products, sectionKey, excludedKeys) {
    var keys = [];
    var exclusions = excludedKeys || [];

    products.forEach(function (product) {
      var section = getIntelligenceSection(
        product,
        sectionKey
      );

      Object.keys(section).forEach(function (key) {
        if (
          exclusions.indexOf(key) !== -1 ||
          keys.indexOf(key) !== -1
        ) {
          return;
        }

        var hasAnyValue = products.some(
          function (candidateProduct) {
            var candidateSection =
              getIntelligenceSection(
                candidateProduct,
                sectionKey
              );

            return hasDisplayValue(candidateSection[key]);
          }
        );

        if (hasAnyValue) {
          keys.push(key);
        }
      });
    });

    return keys;
  }

  function appendIntelligenceSection(
    tbody,
    sectionLabel,
    sectionKey,
    products,
    excludedKeys
  ) {
    var keys = getSectionKeys(
      products,
      sectionKey,
      excludedKeys
    );

    if (!keys.length) {
      return;
    }

    appendSectionRow(
      tbody,
      sectionLabel,
      products
    );

    keys.forEach(function (key) {
      appendStandardRow(
        tbody,
        humanizeCompareKey(key),
        products,
        function (product) {
          var section = getIntelligenceSection(
            product,
            sectionKey
          );

          return formatIntelligenceValue(section[key]);
        }
      );
    });
  }

  function appendStandardRow(
    tbody,
    rowLabel,
    products,
    valueGetter,
    cellClass
  ) {
    var row = document.createElement('tr');

    var values = products.map(function (product) {
      return valueGetter(product) || '—';
    });

    var hasDifferences = valuesAreDifferent(values);

    if (hasDifferences) {
      row.classList.add('ig-compare-row--different');
    }

    var labelCell = createTextCell(
      'th',
      'ig-compare-row-label',
      rowLabel
    );

    labelCell.scope = 'row';

    if (hasDifferences) {
      addDifferenceBadge(labelCell);
    }

    row.appendChild(labelCell);

    products.forEach(function (product, index) {
      var cell = createTextCell(
        'td',
        cellClass || '',
        values[index]
      );

      if (hasDifferences) {
        cell.classList.add(
          'ig-compare-cell--different'
        );
      }

      row.appendChild(cell);
    });

    tbody.appendChild(row);
  }

  function appendSectionRow(tbody, label, products) {
    var row = document.createElement('tr');
    row.className = 'ig-compare-section-row';

    var cell = document.createElement('th');
    cell.scope = 'rowgroup';
    cell.colSpan = products.length + 1;
    cell.textContent = label;

    row.appendChild(cell);
    tbody.appendChild(row);
  }

  function appendCurrentPriceRow(tbody, products) {
    var row = document.createElement('tr');

    var prices = products.map(function (product) {
      return product.price || '—';
    });

    var hasDifferences = valuesAreDifferent(prices);

    if (hasDifferences) {
      row.classList.add('ig-compare-row--different');
    }

    var labelCell = createTextCell(
      'th',
      'ig-compare-row-label',
      'Current Price'
    );

    labelCell.scope = 'row';

    if (hasDifferences) {
      addDifferenceBadge(labelCell);
    }

    row.appendChild(labelCell);

    products.forEach(function (product) {
      var cell = document.createElement('td');
      var price = document.createElement('span');

      price.className = 'ig-compare-current-price';
      price.textContent = product.price || '—';

      if (hasDifferences) {
        cell.classList.add(
          'ig-compare-cell--different'
        );
      }

      cell.appendChild(price);
      row.appendChild(cell);
    });

    tbody.appendChild(row);
  }

  function appendOriginalPriceRow(tbody, products) {
    var row = document.createElement('tr');

    var originalPrices = products.map(function (product) {
      return product.comparePrice || '—';
    });

    var hasDifferences =
      valuesAreDifferent(originalPrices);

    if (hasDifferences) {
      row.classList.add('ig-compare-row--different');
    }

    var labelCell = createTextCell(
      'th',
      'ig-compare-row-label',
      'Original Price'
    );

    labelCell.scope = 'row';

    if (hasDifferences) {
      addDifferenceBadge(labelCell);
    }

    row.appendChild(labelCell);

    products.forEach(function (product) {
      var cell = document.createElement('td');

      if (hasDifferences) {
        cell.classList.add(
          'ig-compare-cell--different'
        );
      }

      if (product.comparePrice) {
        var oldPrice = document.createElement('span');

        oldPrice.className =
          'ig-compare-old-price';

        oldPrice.textContent =
          product.comparePrice;

        cell.appendChild(oldPrice);
      } else {
        cell.textContent = '—';
      }

      row.appendChild(cell);
    });

    tbody.appendChild(row);
  }

  function appendProductLinkRow(tbody, products) {
    var row = document.createElement('tr');

    var labelCell = createTextCell(
      'th',
      'ig-compare-row-label',
      'Product Page'
    );

    labelCell.scope = 'row';
    row.appendChild(labelCell);

    products.forEach(function (product) {
      var cell = document.createElement('td');

      if (product.url) {
        var link = document.createElement('a');
        link.className = 'ig-compare-view-link';
        link.href = product.url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = 'View Product';

        cell.appendChild(link);
      } else {
        cell.textContent = '—';
      }

      row.appendChild(cell);
    });

    tbody.appendChild(row);
  }

  function renderCompareModal() {
    createCompareModal();

    var tableHolder = document.getElementById(
      'ig-compare-table-wrap'
    );

    var products = getStoredProducts();

    tableHolder.innerHTML = '';

    if (products.length < 2) {
      var emptyMessage = document.createElement('p');
      emptyMessage.className =
        'ig-compare-empty-message';

      emptyMessage.textContent =
        'Select at least two products to compare.';

      tableHolder.appendChild(emptyMessage);
      return;
    }

    var table = document.createElement('table');
    table.className = 'ig-compare-table';

    var thead = document.createElement('thead');
    var headingRow = document.createElement('tr');

    headingRow.appendChild(
      createTextCell(
        'th',
        'ig-compare-corner-heading',
        'Product Details'
      )
    );

    products.forEach(function (product) {
      headingRow.appendChild(
        createModalProductHeading(product)
      );
    });

    thead.appendChild(headingRow);
    table.appendChild(thead);

    var tbody = document.createElement('tbody');

    appendSectionRow(
      tbody,
      'General',
      products
    );

    appendCurrentPriceRow(tbody, products);
    appendOriginalPriceRow(tbody, products);

    appendSectionRow(
      tbody,
      'Classification',
      products
    );

    appendTaxonomyRows(tbody, products);

    appendIntelligenceSection(
      tbody,
      'Specifications',
      'specifications',
      products,
      ['cup_size_compatibility']
    );

    appendIntelligenceSection(
      tbody,
      'Features',
      'features',
      products
    );

    appendIntelligenceSection(
      tbody,
      'Compatibility',
      'compatibility',
      products
    );

    appendSectionRow(
      tbody,
      'Links',
      products
    );

    appendProductLinkRow(tbody, products);

    table.appendChild(tbody);
    tableHolder.appendChild(table);
  }

  function openCompareModal() {
    var products = getStoredProducts();

    if (products.length < 2) {
      showCompareNotice(
        'Select at least two products before comparing.'
      );

      return;
    }

    createCompareModal();

    var modal = document.getElementById(
      'ig-compare-modal'
    );

    var tableHolder = document.getElementById(
      'ig-compare-table-wrap'
    );

    previousBodyOverflow =
      document.body.style.overflow;

    document.body.style.overflow = 'hidden';

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');

    if (tableHolder) {
      tableHolder.innerHTML = '';

      var loadingMessage = document.createElement('p');
      loadingMessage.className =
        'ig-compare-empty-message';
      loadingMessage.textContent =
        'Loading product details…';

      tableHolder.appendChild(loadingMessage);
    }

    Promise.all(
      products.map(function (product) {
        return hydrateProductIntelligence(product);
      })
    )
      .then(function () {
        renderCompareModal();
      })
      .catch(function () {
        renderCompareModal();
      });

    var closeButton = modal.querySelector(
      '.ig-compare-dialog-close'
    );

    if (closeButton) {
      window.setTimeout(function () {
        closeButton.focus();
      }, 0);
    }
  }

  function closeCompareModal() {
    var modal = document.getElementById(
      'ig-compare-modal'
    );

    if (!modal || modal.hidden) {
      return;
    }

    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');

    document.body.style.overflow =
      previousBodyOverflow;
  }

  function handleCompareChange(event) {
    var checkbox = event.target.closest(
      '[data-ig-compare]'
    );

    if (!checkbox) {
      return;
    }

    var card = checkbox.closest('.spf-product-card');

    if (!card) {
      return;
    }

    var product = getProductData(card);

    if (!product.id) {
      checkbox.checked = false;
      return;
    }

    var products = getStoredProducts();

    var existingIndex = products.findIndex(
      function (storedProduct) {
        return String(storedProduct.id) ===
          String(product.id);
      }
    );

    if (checkbox.checked) {
      if (existingIndex === -1) {
        if (products.length >= MAX_PRODUCTS) {
          checkbox.checked = false;

          showCompareNotice(
            'You can compare up to four products at a time. Remove one product before selecting another.'
          );

          return;
        }

        products.push(product);
      } else {
        products[existingIndex] = product;
      }
    } else if (existingIndex !== -1) {
      products.splice(existingIndex, 1);
    }

    saveProducts(products);
    renderCompareTray();

    if (checkbox.checked) {
      hydrateProductIntelligence(product);
    }

    var modal = document.getElementById(
      'ig-compare-modal'
    );

    if (modal && !modal.hidden) {
      if (products.length >= 2) {
        renderCompareModal();
      } else {
        closeCompareModal();
      }
    }
  }

  function removeComparedProduct(productId) {
    var products = getStoredProducts().filter(
      function (product) {
        return String(product.id) !==
          String(productId);
      }
    );

    saveProducts(products);
    renderCompareTray();

    var modal = document.getElementById(
      'ig-compare-modal'
    );

    if (modal && !modal.hidden) {
      if (products.length >= 2) {
        renderCompareModal();
      } else {
        closeCompareModal();
      }
    }
  }

  function clearAllComparedProducts() {
    saveProducts([]);
    renderCompareTray();
    closeCompareModal();
  }

  function handleCompareClick(event) {
    var removeButton = event.target.closest(
      '[data-ig-remove-product]'
    );

    if (removeButton) {
      event.preventDefault();
      event.stopPropagation();

      removeComparedProduct(
        removeButton.getAttribute(
          'data-ig-remove-product'
        )
      );

      return;
    }

    if (event.target.closest('#ig-compare-clear')) {
      clearAllComparedProducts();
      return;
    }

    if (
      event.target.closest(
        '#ig-compare-modal-clear'
      )
    ) {
      clearAllComparedProducts();
      return;
    }

    if (event.target.closest('#ig-compare-open')) {
      openCompareModal();
      return;
    }

    if (
      event.target.closest(
        '[data-ig-compare-close]'
      )
    ) {
      closeCompareModal();
    }
  }

  function handleCompareKeydown(event) {
    if (event.key === 'Escape') {
      closeCompareModal();
    }
  }

  function initializeCompareFeature() {
    createCompareTray();
    createCompareModal();
    addCompareCheckboxes();
    syncCompareCheckboxes();
    renderCompareTray();
    hydrateStoredProducts();

    if (!window.IGCompareListenersAdded) {
      document.addEventListener(
        'change',
        handleCompareChange
      );

      document.addEventListener(
        'click',
        handleCompareClick
      );

      document.addEventListener(
        'keydown',
        handleCompareKeydown
      );

      window.IGCompareListenersAdded = true;
    }

    if (!window.IGCompareObserverAdded) {
      var observer = new MutationObserver(function () {
        addCompareCheckboxes();
        syncCompareCheckboxes();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      window.IGCompareObserverAdded = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeCompareFeature
    );
  } else {
    initializeCompareFeature();
  }

  document.addEventListener(
    'globoFilterRenderCompleted',
    function () {
      addCompareCheckboxes();
      syncCompareCheckboxes();
      renderCompareTray();
      hydrateStoredProducts();
    }
  );

  document.addEventListener(
    'shopify:section:load',
    function () {
      addCompareCheckboxes();
      syncCompareCheckboxes();
      renderCompareTray();
      hydrateStoredProducts();
    }
  );
})();